/** React Router's URL path */
export const PATH = '/home'

/** title on the layout header */
export const HEADER = 'My Dashboard'



// WEBPACK FOOTER //
// ./src/pages/home/constants.js